export default "__VITE_ASSET__CeScn8LG__"